export const homeObjOne = {
	pointerProps: {
		"Hands-on Session":
			"Sessions that provide students with varied opportunities of learning on vivid technical topics and incorporating assignments to increase the cope of knowledge.",
		Bootcamps:
			"We conduct 5-6 days Series of Sessions on a specific topic that assist the metamorphosis from primary to maestro levels.",
		Quizzes:
			"For a wide range of technical and non-technical topics we conduct quizzes that help in expansion of knowledge and endorse qualities like healthy competition with fun and excitement.",
		"Technical Debates":
			"Participants debate on given technical topics which include multi-faceted knowledge cutting across several disciplines outside the learner's normal academic subjects.",
	},
};

export const settings = {
	dots: true,
	lazyLoad: true,
	infinite: true,
	speed: 500,
	slidesToShow: 1,
	slidesToScroll: 1,
	initialSlide: 2,
};
